import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export function DashboardPagination({ foundCount, offset, limit, currentPage, totalPages, onPrev, onNext, hideNav = false }) {
  return (
    <footer className="flex items-center justify-between border-t border-zinc-300 px-4 py-2.5 sm:pr-52 lg:px-6 lg:pr-56">
      <span className="text-xs text-zinc-500" data-testid="record-count-label">
        {foundCount.toLocaleString()} records found
      </span>
      {!hideNav && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            className="rounded-sm border-zinc-300"
            disabled={offset <= 1}
            onClick={onPrev}
            data-testid="pagination-prev-button"
          >
            <CaretLeft size={14} />
          </Button>
          <span className="font-mono-data text-xs text-zinc-600" data-testid="pagination-page-label">
            Page {currentPage} / {totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            className="rounded-sm border-zinc-300"
            disabled={offset + limit > foundCount}
            onClick={onNext}
            data-testid="pagination-next-button"
          >
            <CaretRight size={14} />
          </Button>
        </div>
      )}
    </footer>
  );
}
